import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=67c9c995&scoped=true&"
import script from "./TableList.vue?vue&type=script&lang=js&"
export * from "./TableList.vue?vue&type=script&lang=js&"
import style0 from "./TableList.vue?vue&type=style&index=0&id=67c9c995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9c995",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c9c995')) {
      api.createRecord('67c9c995', component.options)
    } else {
      api.reload('67c9c995', component.options)
    }
    module.hot.accept("./TableList.vue?vue&type=template&id=67c9c995&scoped=true&", function () {
      api.rerender('67c9c995', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/widgets/TableList.vue"
export default component.exports